import apiClient from "./client";

/** 三级分类节点（产品型号） */
export interface ModelNode {
  id: string;
  label: string;
}

/** 二级分类节点 */
export interface SubCategoryNode {
  id: string;
  label: string;
  icon: string;
  models: ModelNode[];
}

/** 一级分类节点 */
export interface CategoryNode {
  id: string;
  label: string;
  tKey: string;
  icon: string;
  color: string;
  subCategories: SubCategoryNode[];
}

/** 获取完整分类树 */
export async function getTree(): Promise<CategoryNode[]> {
  const params = new URLSearchParams();
  const res = await apiClient.post("/agentmaterialcategory/getTree.do", params);
  const data = res.data;
  if (data && data.success) {
    return (data.data as CategoryNode[]) ?? [];
  }
  throw new Error(data?.info || "获取分类树失败");
}

/** 新增分类节点 */
export async function addCategory(params: {
  name: string;
  level: number;
  parentId?: string;
  icon?: string;
  color?: string;
  sortId?: number;
}): Promise<{ id: string }> {
  const p = new URLSearchParams();
  p.append("name", params.name);
  p.append("level", String(params.level));
  if (params.parentId) p.append("parentId", params.parentId);
  if (params.icon) p.append("icon", params.icon);
  if (params.color) p.append("color", params.color);
  if (params.sortId != null) p.append("sortId", String(params.sortId));
  const res = await apiClient.post("/agentmaterialcategory/addCategory.do", p);
  const data = res.data;
  if (data && data.success) {
    return data.data as { id: string };
  }
  throw new Error(data?.info || "新增分类失败");
}

/** 更新分类节点 */
export async function updateCategory(params: {
  id: string;
  name?: string;
  icon?: string;
  color?: string;
  sortId?: number;
}): Promise<void> {
  const p = new URLSearchParams();
  p.append("id", params.id);
  if (params.name) p.append("name", params.name);
  if (params.icon) p.append("icon", params.icon);
  if (params.color) p.append("color", params.color);
  if (params.sortId != null) p.append("sortId", String(params.sortId));
  const res = await apiClient.post("/agentmaterialcategory/updateCategory.do", p);
  const data = res.data;
  if (data && data.success) return;
  throw new Error(data?.info || "更新分类失败");
}

/** 删除分类节点（级联删除子节点） */
export async function deleteCategory(id: string): Promise<number> {
  const params = new URLSearchParams();
  params.append("id", id);
  const res = await apiClient.post("/agentmaterialcategory/deleteCategory.do", params);
  const data = res.data;
  if (data && data.success) {
    return (data.data as { deletedCount: number })?.deletedCount ?? 0;
  }
  throw new Error(data?.info || "删除分类失败");
}
